import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import useForm from 'react-hook-form';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { Button, Form } from 'semantic-ui-react';
import cn from 'classnames';
import { changePassword } from '../../redux/modules/user';
import FormSection from '../FormComponents/FormSection';
import ChangePasswordForm from '../FormComponents/ChangePasswordForm/ChangePasswordForm';
import commonStyles from '../../containers/Registration/userFormCommonStyles.module.scss';
import { passwordSchema } from '../../validations/userFormValidations';
import { ReactComponent as PasswordChangeIcon } from '../../img/password_change_icon.svg';

const schema = Yup.object()
  .shape({
    oldPassword: Yup.string().required('validationErrors.isRequired'),
  })
  .concat(passwordSchema);

const PrivacyScreen = () => {
  const dispatch = useDispatch();

  const { updatingPass: isLoading, updatePassError } = useSelector(
    (store) => store.userReducer,
    shallowEqual,
  );

  const { user } = useSelector((store) => store.userReducer, shallowEqual);

  const { t } = useTranslation();

  const { register, handleSubmit, errors, setError, reset } = useForm({
    validationSchema: schema,
    mode: 'onBlur',
  });

  const onSubmit = ({ oldPassword, password, repeatPassword }) => {
    dispatch(
      changePassword(
        {
          current_password: oldPassword,
          password,
          password_confirmation: repeatPassword,
        },
        user.id,
      ),
    );
  };

  useEffect(() => {
    if (!updatePassError && !isLoading) {
      reset();
    }
  }, [updatePassError, isLoading, reset]);

  useEffect(() => {
    if (
      updatePassError
      && updatePassError.errors
      && updatePassError.errors.custom_error
    ) {
      setError(
        updatePassError.errors.custom_error.error_field,
        'invalidOldPass',
        'changePassword.invalidOldPass',
      );
    }
  }, [updatePassError, setError]);

  return (
    <div id={commonStyles.form}>
      <h2
        className={cn(
          'header',
          commonStyles.header,
          commonStyles.mobileContent,
        )}
      >
        {t('changePassword.header')}
      </h2>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        loading={isLoading}
        className={commonStyles.userForm}
      >
        <FormSection
          icon={<PasswordChangeIcon />}
          title={t('changePassword.sectionHeader')}
          bottomBorder
        >
          <ChangePasswordForm
            formProps={{ register, handleSubmit, errors, reset }}
          />
        </FormSection>
        <div className={commonStyles.buttonSection}>
          <Button
            className={cn(commonStyles.submitButton, 'orange_button')}
            type="submit"
          >
            {t('privacyScreen.save')}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default PrivacyScreen;
